import { render, staticRenderFns } from "./b2clogs.vue?vue&type=template&id=628d52be"
import script from "./b2clogs.vue?vue&type=script&lang=js"
export * from "./b2clogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports